import { useQuery } from '@tanstack/react-query';
import type { IAverageRating } from '../types/averageRateTypes';
import { jobsService } from '../jobsService';

export const useAverageRate = (officeId: string) => {
  const { data, error, isFetching, isLoading, isError } = useQuery<IAverageRating>({
    queryKey: ['average-rate', officeId],
    queryFn: () => jobsService.getAverageRate(officeId),
    enabled: !!officeId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
